import { createFileRoute, redirect } from '@tanstack/react-router';
import WelcomeLoggedOutPage from '../components/pages/unauthenticated/welcomeLoggedOut';

export const Route = createFileRoute('/')({
  component: WelcomeLoggedOutPage,
  head: () => ({
    meta: [
      {
        title: 'Welcome | Ingle Lewer',
      },
    ],
  }),
  beforeLoad: async ({ context }) => {
    // Check if the user is authenticated
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      });
    }
  },
});
